import {
    SAVE_COMPARATIVE_VIEW,
    SAVE_COMPARATIVE_DATA,
    SET_CURRENT_TIME,
    SET_CURRENT_DATE,
    SET_ACTIVE_EQUITY,
    SAVE_EQUITY_FINANCIALS,
    SAVE_EQUITY_TIME_SERIES,
    SAVE_EQUITY_KEY_FINANCIALS,
    SAVE_EQUITY_DIVIDEND_HISTORY,
    SAVE_EQUITY_ANNOUNCEMENT,
    SAVE_EQUITY_TEARSHEET,
    SAVE_EQUITY_PRICE_ACTIONS,
    SAVE_TICKERS_DETAIL,
    SET_ACTIVE_COMPARATIVE_VIEW,
    SET_ANNOUNCEMENT_AGM_SGM,
    SET_ANNOUNCEMENT_AUCTION,
    SET_ANNOUNCEMENT_BOND_DEBENTURE,
    SET_ANNOUNCEMENT_DIVIDEND,
    SET_ANNOUNCEMENT_FINANCIALS,
    SET_ANNOUNCEMENT_IPO_FPO,
    SET_ANNOUNCEMENT_NEPSE_CIRCULAR,
    SET_ANNOUNCEMENT_RIGHT_SHARES,
    SET_OVERVIEW_ACTIVE_SECTOR,
    SAVE_OVERVIEW_INDICES_DATA,
    SAVE_OVERVIEW_PRICE_ACTIONS,
    SAVE_OVERVIEW_TOP_BROKERS,
    SAVE_OVERVIEW_TOP_LOSERS_GAINERS,
    SAVE_OVERVIEW_ACTIVE_TURNOVER,
    SAVE_OVERVIEW_TIME_SERIES,
    SAVE_OVERVIEW_SECTOR_DATA,
    SAVE_HOMESCREEN_TODAYS_EVENTS,
    SAVE_HOMESCREEN_TODAYS_ANNOUNCEMENT,
    SAVE_HOMESCREEN_UPCOMING_EVENTS,
    SAVE_HOMESCREEN_MOVERS,
    SAVE_HOMESCREEN_PORTFOLIO,

    SAVE_HOMESCREEN_WATCHLIST_TICKERS,
    SAVE_HOMESCREEN_WATCHLIST,
} from '../action-types/domainData';

// Set Ticker Detai/

export const saveTickersDetailAction = ({ tickersDetail }) => ({
    type: SAVE_TICKERS_DETAIL,
    tickersDetail,
});

// Set Announcements
export const setAnnouncementNepseCircularAction = ({ nepseCircular }) => ({
    type: SET_ANNOUNCEMENT_NEPSE_CIRCULAR,
    nepseCircular,
});

export const setAnnouncementFinancialsAction = ({ financials }) => ({
    type: SET_ANNOUNCEMENT_FINANCIALS,
    financials,
});

export const setAnnouncementIpoFpoAction = ({ ipoFpo }) => ({
    type: SET_ANNOUNCEMENT_IPO_FPO,
    ipoFpo,
});

export const setAnnouncementRightSharesAction = ({ rightShares }) => ({
    type: SET_ANNOUNCEMENT_RIGHT_SHARES,
    rightShares,
});

export const setAnnouncementAuctionAction = ({ auction }) => ({
    type: SET_ANNOUNCEMENT_AUCTION,
    auction,
});

export const setAnnouncementBondDebentureAction = ({ bondDebenture }) => ({
    type: SET_ANNOUNCEMENT_BOND_DEBENTURE,
    bondDebenture,
});

export const setAnnouncementAgmSgmAction = ({ agmSgm }) => ({
    type: SET_ANNOUNCEMENT_AGM_SGM,
    agmSgm,
});

export const setAnnouncementDividendAction = ({ dividend }) => ({
    type: SET_ANNOUNCEMENT_DIVIDEND,
    dividend,
});

// Set Comparative
export const saveComparativeViewAction = ({ view, securities, criteria, pristine }) => ({
    type: SAVE_COMPARATIVE_VIEW,
    view,
    criteria,
    securities,
    pristine,
});

export const saveComparativeActiveViewAction = ({ view }) => ({
    type: SET_ACTIVE_COMPARATIVE_VIEW,
    view,
});

export const saveComparativeDataAction = ({ view, comparativeData }) => ({
    type: SAVE_COMPARATIVE_DATA,
    view,
    comparativeData,
});

export const setActiveEquityAction = ({ ticker }) => ({
    type: SET_ACTIVE_EQUITY,
    ticker,
});

export const saveEquityFinancialAction = ({ data, financialType, format, ticker }) => ({
    type: SAVE_EQUITY_FINANCIALS,
    data,
    financialType,
    format,
    ticker,
});

export const saveEquityTimeSeriesAction = ({ timeInterval, timeSeriesData, ticker }) => ({
    type: SAVE_EQUITY_TIME_SERIES,
    timeInterval,
    timeSeriesData,
    ticker,
});

export const saveEquityTearsheetAction = ({ tearsheetData, dataType, ticker }) => ({
    type: SAVE_EQUITY_TEARSHEET,
    tearsheetData,
    dataType,
    ticker,
});

export const saveEquityPriceActionsAction = ({ data, ticker }) => ({
    type: SAVE_EQUITY_PRICE_ACTIONS,
    data,
    ticker,
});

export const saveEquityDividentHistoryAction = ({ dividentHistory, ticker }) => ({
    type: SAVE_EQUITY_DIVIDEND_HISTORY,
    dividentHistory,
    ticker,
});

export const saveEquityKeyFinancialAction = ({ keyFinancials, ticker }) => ({
    type: SAVE_EQUITY_KEY_FINANCIALS,
    keyFinancials,
    ticker,
});

export const saveEquityAnnouncementAction = ({ announcement, ticker }) => ({
    type: SAVE_EQUITY_ANNOUNCEMENT,
    announcement,
    ticker,
});

export const setOverviewActiveSectorAction = ({ sector }) => ({
    type: SET_OVERVIEW_ACTIVE_SECTOR,
    sector,
});

export const saveOverviewIndicesDataAction = ({ data }) => ({
    type: SAVE_OVERVIEW_INDICES_DATA,
    data,
});

export const saveOverviewPriceActionsAction = ({ data }) => ({
    type: SAVE_OVERVIEW_PRICE_ACTIONS,
    data,
});

export const saveOverviewTopBrokersAction = ({ data }) => ({
    type: SAVE_OVERVIEW_TOP_BROKERS,
    data,
});

export const saveOverviewTopLosersGainersAction = ({ gainers, losers }) => ({
    type: SAVE_OVERVIEW_TOP_LOSERS_GAINERS,
    gainers,
    losers,
});

export const saveOverviewActiveTurnoverAction = ({ mostActive, highestTurnover }) => ({
    type: SAVE_OVERVIEW_ACTIVE_TURNOVER,
    mostActive,
    highestTurnover,
});

export const saveOverviewTimeSeriesAction = ({ lineChart, barChart, sectorType, interval }) => ({
    type: SAVE_OVERVIEW_TIME_SERIES,
    lineChart,
    barChart,
    sectorType,
    interval,
});

export const saveOverviewSectorDataAction = ({ sector, data }) => ({
    type: SAVE_OVERVIEW_SECTOR_DATA,
    sector,
    data,
});

export const saveHomeScreenUpcomingEventsAction = ({ data }) => ({
    type: SAVE_HOMESCREEN_UPCOMING_EVENTS,
    data,
});

export const saveHomeScreenTodaysEventsAction = ({ data }) => ({
    type: SAVE_HOMESCREEN_TODAYS_EVENTS,
    data,
});

export const saveHomeScreenTodaysAnnouncementsAction = ({ data }) => ({
    type: SAVE_HOMESCREEN_TODAYS_ANNOUNCEMENT,
    data,
});

export const saveHomeMoversAction = ({ gainers, losers }) => ({
    type: SAVE_HOMESCREEN_MOVERS,
    gainers,
    losers,
});

export const saveHomePortfolioAction = ({ data }) => ({
    type: SAVE_HOMESCREEN_PORTFOLIO,
    data,
});

export const saveWatchListTickersAction = ({ data }) => ({
    type: SAVE_HOMESCREEN_WATCHLIST_TICKERS,
    data,
});

export const saveWatchListAction = ({ data }) => ({
    type: SAVE_HOMESCREEN_WATCHLIST,
    data,
});

export const setCurrentTimeAction = ({ timeStamp }) => ({
    type: SET_CURRENT_TIME,
    timeStamp,
});

export const setCurrentDateAction = ({ timeStamp }) => ({
    type: SET_CURRENT_DATE,
    timeStamp,
});



// WEBPACK FOOTER //
// ./src/common/action-creators/domainData.js